import { SiteLocale } from "src/__generated__/cms-schema.codegen";
import { defaultMessages } from "src/__generated__/messages";

export const locales = [
	SiteLocale.de,
	SiteLocale.en,
] as const satisfies Array<SiteLocale>;

export type MessageKey = keyof typeof defaultMessages;

export const isMessageKey = (key: string): key is MessageKey =>
	Object.keys(defaultMessages).includes(key);

// 🔬 TBD: Please evaluate
